define(function () {
    function Visibility() {
        var privates = {};
        var publics = {};

        privates.hiddenProperty =
            'hidden' in document
                ? 'hidden'
                : 'webkitHidden' in document
                ? 'webkitHidden'
                : 'mozHidden' in document
                ? 'mozHidden'
                : null;

        privates.visibilityStateProperty =
            'visibilityState' in document
                ? 'visibilityState'
                : 'webkitVisibilityState' in document
                ? 'webkitVisibilityState'
                : 'mozVisibilityState' in document
                ? 'mozVisibilityState'
                : null;

        privates.visibilityChangeEvent = false;

        publics.supported = true;
        publics.hidden = false;
        publics.state = '';
        privates.events = {};

        privates.init = function () {
            if (
                privates.hiddenProperty === null ||
                privates.visibilityStateProperty === null
            ) {
                publics.supported = false;
            }

            privates.visibilityChangeEvent = privates.hiddenProperty.replace(
                /hidden/i,
                'visibilitychange'
            );

            privates.setEvents();
        };

        privates.eventData = function () {
            return JSON.parse(JSON.stringify(publics));
        };

        privates.setEvents = function () {
            if (publics.supported) {
                document.addEventListener(
                    privates.visibilityChangeEvent,
                    function (event) {
                        publics.hidden = document[privates.hiddenProperty];
                        publics.state =
                            document[privates.visibilityStateProperty];

                        publics.trigger('change', privates.eventData());
                    }
                );
            } else {
                $(window).on('focus', function (event) {
                    publics.hidden = false;
                    publics.state = 'visible';

                    publics.trigger('change', privates.eventData());
                });

                $(window).on('blur', function (event) {
                    publics.hidden = true;
                    publics.state = 'hidden';

                    publics.trigger('change', privates.eventData());
                });
            }
        };

        publics.on = function (event, cb) {
            privates.events[event] = privates.events[event] || [];
            privates.events[event].push(cb);
        };

        publics.trigger = function (event, data) {
            if (!privates.events[event]) return false;

            $.each(privates.events[event], function (key, cb) {
                if (_.isFunction(cb)) {
                    cb(data);
                }
            });
        };

        privates.init();

        return publics;
    }

    return Visibility;
});
